import { ChargeDetails } from "src/dto/response/fetchBookingBreakdown";

export const chargeCategoryKeyLabelMap = {
  originCharges: 'Origin Charges',
  destinationCharges: 'Destination Charges',
  freightCharges : 'Freight Charges'
};

export const chargeCategoryLabelKeyMap = {
  'Origin Charges': 'originCharges',
  'Destination Charges': 'destinationCharges',
  'Freight Charges': 'freightCharges',
};

export const defaultChargeDetails = {
  originCharges: {
    name: 'Origin Charges',
    values: [],
  },
  freightCharges: {
    name: 'Freight Charges',
    values: [{
      currency: 'INR',
      unitType: undefined as string | undefined,
      name: undefined as string | undefined,
      tax: undefined as string | undefined,
      price: 0,
      unitCount: 1,
      // total: 0,
      containerType: undefined as string | undefined,
      containerSize: undefined as string | undefined,
      hsnCode: undefined as string | undefined,
    }],
  },
  destinationCharges: {
    name: 'Destination Charges',
    values: [],
  },
};

export const orderedChargesKeys = ['originCharges', 'freightCharges', 'destinationCharges'];
export enum invoicingColors {
  priceUp = '#F72804',
  priceDown = '#14B76B',
};
